import { useCookies } from "react-cookie";
import { Navigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import { useDispatch } from "react-redux";
import { setAuth } from "../state/authReducer";

const AuthGuard = ({children})=>{
    const [cookies] = useCookies(['token'])
    const dispatch = useDispatch()

    if(cookies["token"]==null){
        return <Navigate to={"/login"} replace/>
}
    const decoded = jwtDecode(cookies["token"])
    const jsonData = JSON.parse(decoded.userInfo)
        dispatch(setAuth({
        user:jsonData.username,
        role:jsonData.roles.name,
        companyId:jsonData.companies.id,
        userId:jsonData.id,
        first_time:jsonData.first_time&&jsonData.roles.name!=="Super Admin",
        }))
    return <>{children}</>
}

export default AuthGuard;